<template>
  <div>
    <div class="btn-group" v-if="row.status.id == 'enc'">
      <span class="span-icon warning ml-4 px-2 py-1"><span class="icon icon-circle-clock mr-1"></span>{{row.status.name}}</span>
    </div>
    <div class="btn-group" v-if="row.status.id == 'pri' || row.status.id == 'sgd'">
      <span class="span-icon warning ml-4 px-2 py-1"><img src="@/assets/images/icons/icon-warning-circle.svg" class="icon mr-1"/>{{row.status.name}}</span>
    </div>
    <div class="btn-group" v-if="row.status.id == 'trm' || row.status.id == 'csc'">
      <span class="span-icon success ml-4 px-2 py-1"><span class="icon icon-checkmark mr-1"></span>{{row.status.name}}</span>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EstadoLegal",
  data() {
    return {
      selected: false
    }
  },
  props: ['row', 'field'],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift", "selectAll"]),
    ...mapGetters([
      'modTipshiftReport',
      ["getAllSelected"]
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad"
    ]),

    eliminarRegistroNovedad(id) {
      this.actEliminarRegistroNovedad(id);
    },

  },
};
</script>

<style lang="scss" scoped>
.icon-checkmark,
.icon-circle-clock,
.icon-warning {

  margin-right: 0.5rem;
}

.warning {
  color: #E66401;
}

.success {
  color: #00761A;
}

.span-icon {
  background: #F6FFED;
  border-radius: 8px;
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}
</style>